import { defineComponent as r, computed as t } from "vue";
import a from "../index.js";
import { AvailableContractsSearchSubmitHandler as o } from "./index5.js";
const p = r({
  name: "AvailableContractsSearch",
  props: {
    searchRedirectionHost: {
      type: String,
      default: ""
    },
    availableContracts: {
      type: Array,
      required: !0
    },
    algoliaExpVar: {
      type: String,
      required: !0
    },
    placeholder: {
      type: String
    },
    config: {
      type: Object,
      required: !0
    }
  },
  components: {
    Search: a
  },
  setup(e) {
    return {
      searchSubmitHandler: t(
        () => new o(
          String(e.searchRedirectionHost)
        )
      )
    };
  }
});
export {
  p as default
};
//# sourceMappingURL=index4.js.map
